import { Controller } from "stimulus";

export default class extends Controller {

    connect(){
        if((navigator.userAgent.toLowerCase().indexOf("android") > -1 || navigator.userAgent.toLowerCase().indexOf("iphone") > -1) && document.getElementById("deeplink-url") !== null){
            window.location.href = document.getElementById("deeplink-url").innerText;
        }else {
            document.getElementById("partner-page").style.display = "block";
        }
    }
}
